import { LogoMark } from "@ava/shared/components/design-system";
import { LANDING_BRAND } from "@/pages/home/landingContent";

/** Header sobre el gradiente: el isotipo gris no contrasta sobre azul, va en una ficha blanca. */
export function LandingHeader() {
  return (
    <header className="relative flex-none">
      <div className="mx-auto flex h-15 w-full max-w-7xl items-center px-4 md:h-20 md:px-8">
        <div className="flex items-center gap-2.5 md:gap-3">
          <span className="flex size-9 items-center justify-center rounded-lg bg-card md:size-10">
            <LogoMark size={24} />
          </span>
          <div>
            <span className="block font-bold leading-tight tracking-tight text-white">{LANDING_BRAND.name}</span>
            <span className="block text-xs leading-tight text-white/90">{LANDING_BRAND.product}</span>
          </div>
        </div>
      </div>
    </header>
  );
}
